module.exports = __webpack_public_path__ + "img/heng_liu.eef8408b.png";